module.exports = __webpack_public_path__ + "static/media/instrument.52b86359.svg";